module.exports = __webpack_public_path__ + "img/ship.476fb7fe.png";